import { TrnxCommonService } from './../../shared/services/trnx-common.service';
import { TrnxCommonTs } from 'src/app/shared/common/trnxCommonTs';
import { Component, OnInit } from '@angular/core';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/shared/services/common.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxUiLoaderService } from 'ngx-ui-loader';


@Component({
    selector: 'app-about-us',
    templateUrl: './about-us.component.html',
    styleUrls: ['./about-us.component.scss'],
    standalone: false
})
export class AboutUsComponent implements OnInit {
  properties=[] ;


  backgroundColorButton = "";
  allocateButtons1Boolean = false;
  allocateButtonsBoolean = false;
  bootstrapColumn: any;
  closeIconButton1Boolean = false;
  closeIconButtonBoolean = false;
  backgroundColorScreen="";
  buttonColor="";
  jsuiteVersion="";
  jsuiteEnv="";
  jsuitBuild="";
  accessToken: any;
  userGuideUrl: any;
  jsuiteHelpUrl: any;
  jsuitUserGuideAcessToken: any;

  constructor(private dialogref: MatDialogRef<AboutUsComponent>,private localStorageSettings: LocalStorageSettingsService,private commanService: CommonService,private spinner: NgxUiLoaderService,private trnxCommonService:TrnxCommonService) { }

  ngOnInit() {
    let tenatId=0;
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
    let chekingTenantid=this.localStorageSettings.getSettings('dnsName');
    if (chekingTenantid != null) {
tenatId=Number(chekingTenantid);
console.log(typeof tenatId);

  }
 this.returnJsuiteProperty(tenatId);
  

  //this.commanService.retrieveSingleJsuiteRecord(0,"jsuiteversion");
  

    if (this.bootstrapColumn == 1) {

      this.allocateButtons1Boolean = true;

      this.closeIconButton1Boolean = true;

    }
    else {

      this.allocateButtonsBoolean = true;

      this.closeIconButtonBoolean = true;

    }

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);
   this. gettingVersionDetail();
   this.retrieveAcessToken();
  }

  close(){
    this.dialogref.close();
  }

/*
Author:Abhishek T
Date:17-07-2023
this method for reterive the parameters value which is in about page
*/
  
async returnJsuiteProperty(tenantId: number): Promise<void> {
  this.spinner.start();
  try {
    const response = await this.commanService.retrieveJsuiteRecord(tenantId);
    for (const obj of response) {
      if (obj.propertyname === 'jsuiteversion') {
        // this.jsuiteVersion = obj.propertyvalue;
      } else if (obj.propertyname === 'jsuiteenvironment') {
        this.jsuiteEnv = obj.propertyvalue;
      } else if (obj.propertyname === 'jsuitebuild') {
        this.jsuitBuild = obj.propertyvalue;
      }
    }
  } catch (error) {
    console.error(error);
    throw error; 
  }

  this.spinner.stop();
}


async gettingVersionDetail() {
  this.spinner.start();

  try {
    const response = await this.commanService.retrieveAboutRecord();
console.log(response);
console.log(this.properties);
    // Check if the response is an array
    if (Array.isArray(response) && response.length > 0) {
      // Assign the entire response array to this.properties
      this.properties = response;
      console.log(this.properties);
    } else {
      // Handle the case where the response is empty or not an array
      console.error('Response is empty or not in the expected format.');
    }
    console.log(this.properties);
  } catch (error) {
    console.error(error);
    throw error;
  }

  this.spinner.stop();
}
generateCombinedUrl(): string {
 
  if (this.userGuideUrl && this.accessToken) {
    return `${this.userGuideUrl}?accessToken=${(this.accessToken)}`;
  }
  return '';
}
/*
Author:Venkata Shyam 
Date:16-01-2025
this method for reterive accessoken and userguideurl which is in about page
*/

  async retrieveAcessToken() {
    
    try {
      const response = await this.commanService.retrieveAccessTokenForUserGuide().toPromise();
      
      if (response && response.length > 0) {
        const data = response[0]; // Use the first object in the array
        this.jsuiteVersion = data.jsuiteversion;
        this.accessToken = data.accesstoken; // Extract "accesstoken"
        this.userGuideUrl = data.userguideurl; // Extract "userguideurl"
        console.log('Access Token:', this.accessToken);
        console.log('User Guide URL:', this.userGuideUrl);
      } else {
        console.error('No data found in the API response.');
      }
    } catch (error) {
      console.error('Error retrieving access token:', error);
    } finally {
      this.spinner.stop();
    }
    this.jsuiteHelpUrl=this. generateCombinedUrl();
  }
  

    
  
  
  
}
